import { usePageInfo } from '../../../config/queries'

export const STEP_IDS = [
  'team',
  'roster',
  'events',
  'recruitment',
  'loot',
  'notifications',
  'access',
] as const

export const useOnboardingSteps = () => {
  const {
    data: { gameVersion },
  } = usePageInfo()

  return STEP_IDS.filter((id) => id !== 'loot' || gameVersion === 'live')
}
